// file size is measured in bytes 1Mo = 1 * 1024 * 1024
export const maxFilesSize = 10485760;

export const pathLinks = Object.freeze({
  home: "",
  users: "/utilisateurs",
  usersTechnician: "/utilisateurs/techniciens",
  usersClients: "/utilisateurs/clients",
  system: "/systemes",
  systemAdmin: "/systemes/admins",
  systemSupport: "/systemes/moderateurs",
  offer: "/annonces",
  intervention: "/interventions",
  // interventionCalendar: "/interventions/calendrier",
  chatRoom: "/messages",
  sector: "/secteurs",
  category: "/categories",
  subCategory: "/sous-categories",
  ticket: "/tickets",
  signin: "/connexion",
  forgetPassword: "/forgot-password",
  resetPassword: "/reset-password",
  invoice: "/factures",
  invoiceTechnicians: "/factures/techniciens",
  invoiceClients: "/factures/clients",
  myProfile: "/mon-profil",
  review: "/avis",
  error: "/error",
  commission: "/commission",
});

export const genderList = [
  {
    label: "M.",
    value: "M",
  },
  {
    label: "Mr.",
    value: "Mr",
  },
];

export const accountStatus = Object.freeze({
  INITIATED: "INITIATED",
  VALIDATION_WAITING: "VALIDATION_WAITING",
  VALID: "VALID",
  DISABLED: "DISABLED",
  DISALLOW: "DISALLOW",
});

export const signedBy = Object.freeze({
  PASSWORD: "PASSWORD",
  FACEBOOK: "FACEBOOK",
  GOOGLE: "GOOGLE",
  APPLE: "APPLE",
});

export const userRoleList = Object.freeze({
  CLIENT: "CLIENT",
  TECHNICIAN: "TECHNICIAN",
  ADMIN: "ADMIN",
  SUPPORT: "SUPPORT",
});
export const userRolesFrench = Object.freeze({
  CLIENT: "Client",
  TECHNICIAN: "Technicien",
  ADMIN: "Administrateur",
  SUPPORT: "Modérateur",
});

export const userGender = Object.freeze({
  M: "M",
  Mr: "Mr",
});

export const documentType = Object.freeze({
  CNI_UP: "CNI_UP",
  PASSPORT: "PASSPORT",
  CNI_DOWN: "CNI_DOWN",
  DIPLOMA: "DIPLOMA",
  INVOICE: "INVOICE",
  ATTACHMENT: "ATTACHMENT",
    REALIZATION: "REALIZATION",
});

export const fileTypeRelation = Object.freeze({
  technician: "technician",
  offer: "offer",
  chatMessage: "chatMessage",
  intervention: "intervention",
});

export const offerStatus = Object.freeze({
  VALIDATION_WAITING: "VALIDATION_WAITING",
  PUBLIC: "PUBLIC",
  PROCESSING: "PROCESSING",
  ENDED: "ENDED",
  DISABLED: "DISABLED",
  DISALLOW: "DISALLOW",
});

export const reviewStatus = Object.freeze({
  PENDING: "PENDING",
  PUBLISHED: "PUBLISHED",
  REJECTED: "REJECTED",
});

export const proposalStatus = Object.freeze({
  INITIATED: "INITIATED",
  HIDDEN: "HIDDEN",
  REFUSED: "REFUSED",
  INTERVENTION_CREATED: "INTERVENTION_CREATED",
  ACCEPTED: "ACCEPTED",
  CANCELLED: "CANCELED",
  OFFER_HANDLED: "OFFER_HANDLED",
  INTERVENTION_DECLINED: "INTERVENTION_DECLINED",
  ENDED: "ENDED",
});

export const interventionStatus = Object.freeze({
  PROCESSING: "PROCESSING",
  ENDED: "ENDED",
  // HIDDEN: "HIDDEN",
  CANCELED: "CANCELED",
  // DISALLOW: "DISALLOW",
  NEW: "NEW",
  REPORTED: "REPORTED",
});

export const frenchStatus = Object.freeze({
  PROCESSING: "En cours",
  ENDED: "Terminé",
  CANCELED: "Annulées",
  DISALLOW: "Rejetés",
  INITIATED: "Nouveaux",
  HIDDEN: "Bloqué",
  REFUSED: "Refusé",
  INTERVENTION_CREATED: "INTERVENTION_CRÉÉE",
  OFFER_HANDLED: "OFFRE_TRAITÉE",
  INTERVENTION_DECLINED: "INTERVENTION_REFUSÉE",
  VALIDATION_WAITING: "En attente",
  PUBLIC: "Publiées",
  DISABLED: "Bloqués",
  RESOLVED: "Résolus",
  ARCHIVE: "Archivés",
  ACCEPTED: "Accepté",
  CLOSED: "FERMÉ",
  PENDING: "EN_ATTENTE",
  DELIVERED: "Livré",
  FAILED: "Échoué",
  PAID: "Payée",
  NOT_PAID: "Non payée",
  VALID: "Actifs",
});

export const ticketStatus = Object.freeze({
  INITIATED: "INITIATED",
  PROCESSING: "PROCESSING",
  RESOLVED: "RESOLVED",
  UNRESOLVED: "UNRESOLVED",
  ARCHIVED: "ARCHIVED",
});

export const chatRoomStatus = Object.freeze({
  INITIATED: "INITIATED",
  ACCEPTED: "ACCEPTED",
  CANCELED: "CANCELED",
  CLOSED: "CLOSED",
  ENDED: "ENDED",
  HIDDEN: "HIDDEN",
  // OFFER_CANCELED: "OFFER_CANCELED",
  // OFFER_HANDLED: "OFFER_HANDLED",
});

export const notificationType = Object.freeze({
  TECHNICIAN: "TECHNICIAN",
  OFFER: "OFFER",
  TICKET: "TICKET",
});

export const notificationStatus = Object.freeze({
  PENDING: "PENDING",
  DELIVERED: "DELIVERED",
  FAILED: "FAILED",
});

export const fileFormat = Object.freeze({
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  PDF: "PDF",
  OTHER: "OTHER",
});

export const invoiceStatus = Object.freeze({
  PAID: "PAID",
  NOT_PAID: "NOT_PAID",
});

export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const MAX_VIDEO_SIZE = 20 * 1024 * 1024;

export const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}/i;
export const phoneRegex = /(?:(?:\+33\s?|0)[1-9](?:[\s.-]?\d{2}){4})/;
